import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      // {
      //   path: 'productCate',
      //   name: 'productCate',
      //   component: () => import('@/views/pms/productCate/index'),
      //   meta: {title: '商品分类', icon: 'product-cate'}
      // },
      // {
      //   path: 'addProductCate',
      //   name: 'addProductCate',
      //   component: () => import('@/views/pms/productCate/add'),
      //   meta: {title: '添加商品分类'},
      //   hidden: true
      // },
      // {
      //   path: 'updateProductCate',
      //   name: 'updateProductCate',
      //   component: () => import('@/views/pms/productCate/update'),
      //   meta: {title: '修改商品分类'},
      //   hidden: true
      // },
      // {
      //   path: 'productAttr',
      //   name: 'productAttr',
      //   component: () => import('@/views/pms/productAttr/index'),
      //   meta: {title: '商品类型', icon: 'product-attr'}
      // },
      // {
      //   path: 'productAttrList',
      //   name: 'productAttrList',
      //   component: () => import('@/views/pms/productAttr/productAttrList'),
      //   meta: {title: '商品属性列表'},
      //   hidden: true
      // },
      // {
      //   path: 'addProductAttr',
      //   name: 'addProductAttr',
      //   component: () => import('@/views/pms/productAttr/addProductAttr'),
      //   meta: {title: '添加商品属性'},
      //   hidden: true
      // },
      // {
      //   path: 'updateProductAttr',
      //   name: 'updateProductAttr',
      //   component: () => import('@/views/pms/productAttr/updateProductAttr'),
      //   meta: {title: '修改商品属性'},
      //   hidden: true
      // },
      // {
      //   path: 'brand',
      //   name: 'brand',
      //   component: () => import('@/views/pms/brand/index'),
      //   meta: {title: '品牌管理', icon: 'product-brand'}
      // },
      // {
      //   path: 'addBrand',
      //   name: 'addBrand',
      //   component: () => import('@/views/pms/brand/add'),
      //   meta: {title: '添加品牌'},
      //   hidden: true
      // },
      // {
      //   path: 'updateBrand',
      //   name: 'updateBrand',
      //   component: () => import('@/views/pms/brand/update'),
      //   meta: {title: '编辑品牌'},
      //   hidden: true
      // },
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/pms/group/index'),
        meta: {title: '分组管理', icon: 'product-brand'}
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order-list',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'pending-order',
        name: 'pending-order',
        component: () => import('@/views/oms/pending-order/index'),
        meta: {title: '待处理列表', icon: 'product-list'}
      },
      {
        path: 'order-list',
        name: 'order-list',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'prepare-meals',
        name: 'prepare-meals',
        component: () => import('@/views/oms/prepare-meals/index'),
        meta: {title: '商品备餐'},
      },
      {
        path: 'running-record',
        name: 'running-record',
        component: () => import('@/views/oms/running-record/index'),
        meta: {title: '跑腿记录'},
      },
      // {
      //   path: 'deliverOrderList',
      //   name: 'deliverOrderList',
      //   component: () => import('@/views/oms/order/deliverOrderList'),
      //   meta: {title: '发货列表'},
      //   hidden:true
      // },
      // {
      //   path: 'orderSetting',
      //   name: 'orderSetting',
      //   component: () => import('@/views/oms/order/setting'),
      //   meta: {title: '订单设置', icon: 'order-setting'}
      // },
      // {
      //   path: 'returnApply',
      //   name: 'returnApply',
      //   component: () => import('@/views/oms/apply/index'),
      //   meta: {title: '退货申请处理', icon: 'order-return'}
      // },
      // {
      //   path: 'returnReason',
      //   name: 'returnReason',
      //   component: () => import('@/views/oms/apply/reason'),
      //   meta: {title: '退货原因设置', icon: 'order-return-reason'}
      // },
      // {
      //   path: 'returnApplyDetail',
      //   name: 'returnApplyDetail',
      //   component: () => import('@/views/oms/apply/applyDetail'),
      //   meta: {title: '退货原因详情'},
      //   hidden:true
      // }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [//Issuance record
      // {
      //   path: 'flash',
      //   name: 'flash',
      //   component: () => import('@/views/sms/flash/index'),
      //   meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      // },
      // {
      //   path: 'flashSession',
      //   name: 'flashSession',
      //   component: () => import('@/views/sms/flash/sessionList'),
      //   meta: {title: '秒杀时间段列表'},
      //   hidden:true
      // },
      // {
      //   path: 'selectSession',
      //   name: 'selectSession',
      //   component: () => import('@/views/sms/flash/selectSessionList'),
      //   meta: {title: '秒杀时间段选择'},
      //   hidden:true
      // },
      // {
      //   path: 'flashProductRelation',
      //   name: 'flashProductRelation',
      //   component: () => import('@/views/sms/flash/productRelationList'),
      //   meta: {title: '秒杀商品列表'},
      //   hidden:true
      // },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'coupon-template',
        name: 'coupon-template',
        component: () => import('@/views/sms/coupon-template/index'),
        meta: {title: '优惠券模板', icon: 'sms-coupon'}
      },
      {
        path: 'coupon-template-add',
        name: 'coupon-template-add',
        component: () => import('@/views/sms/coupon-template/add'),
        meta: {title: '新增优惠券模板', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'collect-coupon',
        name: 'collect-coupon',
        component: () => import('@/views/sms/collect-coupon/index'),
        meta: {title: '领券页面', icon: 'sms-coupon'}
      },
      {
            path: 'add-collect-coupon',
        name: 'add-collect-coupon',
        component: () => import('@/views/sms/collect-coupon/add'),
        meta: {title: '新增领券页', icon: 'sms-coupon'}
      },
      {
        path: 'edit-collect-coupon',
        name: 'edit-collect-coupon',
        component: () => import('@/views/sms/collect-coupon/edit'),
        meta: {title: '编辑领券页', icon: 'sms-coupon'}
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'issuance-record',
        name: 'issuance-record',
        component: () => import('@/views/sms/issuance-record/index'),
        meta: {title: '发券纪录', icon: 'sms-flash'}
      },
      // {
      //   path: 'brand',
      //   name: 'homeBrand',
      //   component: () => import('@/views/sms/brand/index'),
      //   meta: {title: '品牌推荐', icon: 'product-brand'}
      // },
      // {
      //   path: 'new',
      //   name: 'homeNew',
      //   component: () => import('@/views/sms/new/index'),
      //   meta: {title: '新品推荐', icon: 'sms-new'}
      // },
      // {
      //   path: 'hot',
      //   name: 'homeHot',
      //   component: () => import('@/views/sms/hot/index'),
      //   meta: {title: '人气推荐', icon: 'sms-hot'}
      // },
      // {
      //   path: 'subject',
      //   name: 'homeSubject',
      //   component: () => import('@/views/sms/subject/index'),
      //   meta: {title: '专题推荐', icon: 'sms-subject'}
      // },
      // {
      //   path: 'advertise',
      //   name: 'homeAdvertise',
      //   component: () => import('@/views/sms/advertise/index'),
      //   meta: {title: '广告列表', icon: 'sms-ad'}
      // },
      // {
      //   path: 'addAdvertise',
      //   name: 'addHomeAdvertise',
      //   component: () => import('@/views/sms/advertise/add'),
      //   meta: {title: '添加广告'},
      //   hidden:true
      // },
      // {
      //   path: 'updateAdvertise',
      //   name: 'updateHomeAdvertise',
      //   component: () => import('@/views/sms/advertise/update'),
      //   meta: {title: '编辑广告'},
      //   hidden:true
      // }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'printer',
        name: 'printer',
        component: () => import('@/views/ums/printer/index'),
        meta: {title: '打印机管理'},
        hidden: true
      }
    ]
  },
  {
    path:'/user',
    component: Layout,
    redirect: '/user/user-list',
    name: 'user',
    meta: {title: '用户列表', icon: 'ums'},
    children: [
      {
        path: 'user-list',
        name: 'user-list',
        component: () => import('@/views/user/user-list/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'user-info',
        name: 'user-info',
        component: () => import('@/views/user/user-info/index'),
        meta: {title: '用户详情', icon: 'ums-admin'},
        hidden:true
      },
    ]
  },
  {
    path:'/shop',
    component: Layout,
    redirect: '/shop/shop-list',
    name: 'shop',
    meta: {title: '门店', icon: 'ums'},
    children: [
      {
        path: 'shop-list',
        name: 'shop-list',
        component: () => import('@/views/shop/shop-list/index'),
        meta: {title: '门店列表', icon: 'ums-admin'}
      },
      {
        path: 'shop-add',
        name: 'shop-add',
        component: () => import('@/views/shop/shop-list/add'),
        meta: {title: '新增门店', icon: 'ums-admin'},
        hidden:true
      },
      {
        path: 'shop-update',
        name: 'shop-update',
        component: () => import('@/views/shop/shop-list/update'),
        meta: {title: '编辑门店', icon: 'ums-admin'},
        hidden:true
      },
      {
        path: 'table-number',
        name: 'table-number',
        component: () => import('@/views/shop/table-number/index'),
        meta: {title: '桌号管理', icon: 'ums-admin'},
        hidden:true
      },
    ]
  },
  {
    path:'/distribution',
    component: Layout,
    redirect: '/distribution/logistics-list',
    name: 'distribution',
    meta: {title: '配送', icon: 'ums'},
    children: [
      {
        path: 'logistics-list',
        name: 'logistics-list',
        component: () => import('@/views/distribution/logistics-list/index'),
        meta: {title: '物流管理', icon: 'ums-admin'}
      },
      {
        path: 'distribution-cost',
        name: 'distribution-cost',
        component: () => import('@/views/distribution/distribution-cost/index'),
        meta: {title: '配送费用设置', icon: 'ums-admin'},
      },
      {
        path: 'distribution-time',
        name: 'distribution-time',
        component: () => import('@/views/distribution/distribution-time/index'),
        meta: {title: '配送时间设置', icon: 'ums-admin'},
      },
      //lifting time
      {
        path: 'lifting-time',
        name: 'lifting-time',
        component: () => import('@/views/distribution/lifting-time/index'),
        meta: {title: '自提时间管理', icon: 'ums-admin'},
      },
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/lucky-draw-list',
    name: 'activity',
    meta: {title: '活动', icon: 'ums'},
    children: [
      {
        path: 'lucky-draw-list',
        name: 'lucky-draw-list',
        component: () => import('@/views/activity/lucky-draw-list/index'),
        meta: {title: '抽奖活动', icon: 'ums-admin'},
      },
      {
        path: 'add-lucky-draw',
        name: 'add-lucky-draw',
        component: () => import('@/views/activity/lucky-draw-list/add'),
        meta: {title: '新增抽奖', icon: 'ums-admin'},
        hidden: false
      },
      {
        path: 'edit-lucky-draw',
        name: 'edit-lucky-draw',
        component: () => import('@/views/activity/lucky-draw-list/edit'),
        meta: {title: '编辑抽奖', icon: 'ums-admin'},
        hidden: false
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js